module.exports = __webpack_public_path__ + "img/shadow_heart_mask.b711a9b0.png";